import React from 'react';

import A from 'wanderu-component-react-router-link';
import {
    Lightbox,
    Modal,
    WDSButton,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './UnavailableModal.scss';

import type { TFunction } from 'i18next';

interface UnavailableModalProps {
    t: TFunction;
    onClick?: () => void;
    changeTripUrl?: string;
}

export const UnavailableModal: React.FC<UnavailableModalProps> = ({
    changeTripUrl = '',
    onClick = () => undefined,
    t,
}) => {
    const backButtonText = changeTripUrl === '/'
        ? t('back-homepage-button')
        : t('back-to-search');

    return (
        <Modal>
            <Lightbox
                innerClassName={styles.container}
                showCloseButton={false}
            >
                <div className={styles.text}>
                    {t<string>('trip-unavailable')}
                </div>
                <A
                    component={WDSButton}
                    componentProps={{
                        color: 'secondary',
                    }}
                    href={changeTripUrl}
                    onClick={onClick}
                    underline={'none'}
                >
                    {backButtonText}
                </A>
            </Lightbox>
        </Modal>
    );
};

export default localize(UnavailableModal, ['t'], 'baseApp');
